/* eslint-disable */
import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import MaterialReactTable from "material-react-table";
import { useSnackbar } from 'notistack';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from "@mui/icons-material/Edit";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Box, IconButton, Container,Button } from '@mui/material';
import Page from '../../../components/Page';
import { PATH_DASHBOARD } from '../../../routes/paths';
// import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
// import Button from 'src/theme/overrides/Button';
// import Button from '../../../theme/overrides/Button';
import Iconify from '../../../components/Iconify';
import axiosInstance from '../../../utils/axios';

export default function FiltertwoTable({demage}) {

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 10,
      },
      {
        accessorKey: "associate_statement",
        header: "Associate Statement",
        size: 10,
      },
      {
        accessorKey: "incident_date",
        header: "Date",
        size: 10,
      },
      {
        accessorKey: "incident_type",
        header: "Incident Type",
        size: 10,
      },
      {
        accessorKey: "police_department",
        header: "Police Department",
        size: 10,
      },
      {
        accessorKey: "city",
        header: "City",
        size: 10,
      },
      {
        accessorKey: "state",
        header: "State",
        size: 10,
      },
      {
        accessorKey: "street",
        header: "Street",
        size: 10,
      },
      {
        accessorKey: "claim_number",
        header: "Claim Number",
        size: 10,
      },
      {
        accessorKey: "incident_type",
        header: "Type of Damage",
        size: 10,
      },
     
      {
        accessorKey: "test_result",
        header: "Results",
        size: 10,
      },
      {
        accessorKey: "at_fault",
        header: "At Fault",
        size: 10,
      },
      
      {
        accessorKey: "drug_test_date",
        header: "Drug Test Date",
        size: 10,
      },
      // {
      //   accessorKey: "est_cost",
      //   header: "Est. Cost",
      //   size: 10,
      // },
      {
        accessorKey: "verified",
        header: "verified",
        size: 10,
      },
      {
        accessorKey: "witness_name",
        header: "Witness Name",
        size: 10,
      },
      {
        accessorKey: "witness_statement",
        header: "Witness Statement",
        size: 10,
      },
      {
        accessorKey: "zipcode",
        header: "Zip Code",
        size: 10,
      },
    //   {
    //     accessorKey: "actions",
    //     header: "Actions",
    //     size: 10,
    //     Cell: ({ row }) => (
    //       <Box>
    //         <IconButton
    //           color="primary"
    //           sx={{
    //             border: "1px solid",
    //             borderColor: "primary.main",
    //             marginRight: "5px" // Add margin to create a gap
    //           }}
    //           onClick={() => { navigate(`/dashboard/vdemage/${row.original.id}`,{state:{name:row.original , ID:id}}) }}
    //         >
    //           <EditIcon />
    //         </IconButton>
    //         <IconButton
    //           color="error"
    //           sx={{
    //             border: "1px solid",
    //             borderColor: "error.main",
    //           }}
    //           onClick={() => {handleDelete(row.original.id);}}
    //         >
    //           <DeleteIcon />
    //         </IconButton>
    //       </Box>
    //     ),
    //   },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  

 


  return (
    <Page title="Vehicle Demage">
      <Container maxWidth='lg'>
      <HeaderBreadcrumbs
          heading="Vehicle Demage"
          links={[
            { name: '', href: '' },]}
          action={
            <>
            </>
            // <Button
            //   variant="contained"
            //   startIcon={<Iconify icon="eva:plus-fill" />}
            //   component={RouterLink}
            //   to={`/dashboard/demage/${id}`}
            //   // onClick={() => { navigate(`/dashboard/vdemage` ) }}


            // >
            // Vehicle Demage
            // </Button>
          }
        />
        <MaterialReactTable
          columns={columns}
          // data={demage[0]?.vehicle_demages || []}
          data={demage?.map((e)=>e?.vehicle_demages) || []}
          enableRowActions={false} // Disable default row actions
        />
      </Container>
    </Page>
  );
}
